import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import validators from '../../utils/validators';
import Overlay from '../../forms/_common/Overlay';
import FormErrors from '../../forms/_common/FormErrors';
import RequestError from '../../forms/_common/RequestError';
import ErrorMessage from '../../forms/_common/ErrorMessage';
import SuccessMessage from '../../forms/_common/SuccessMessage';
import Form from './Form';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import Confirmation from './Confirmation';
import { useQueryMutation } from '@lore/query-connect';

Dialog.propTypes = {
  network: PropTypes.object.isRequired
};

export default function Dialog(props) {
  const { network } = props;

  const [data, setData] = useState({
    name: network.data.name,
    subdomain: network.data.subdomain,
    logo: network.data.logo,
    screeningUrl: network.data.screeningUrl,
    trainingUrl: network.data.trainingUrl,
    googleDriveUrl: network.data.googleDriveUrl,
    educatorBanner: network.data.educatorBanner,
    partnerBanner: network.data.partnerBanner,
    grants: network.data.grants,
    isActive: network.data.isActive,
    city: network.data.city,
    state: network.data.state
  });
  const [showErrors, setShowErrors] = useState(false);

  const mutation = useQueryMutation('network.update', network);
  const { saving, success, error, request } = mutation;

  useEffect(() => {
    if (success) {
      // props.onClose();
      props.onSubmit && props.onSubmit(request);
    }
  }, [success]);

  function onSubmit() {
    mutation.mutate(data);
  }

  function onChange(name, value) {
    const nextData = _.merge({}, data);
    nextData[name] = value;
    setData(nextData);
  }

  return (
    <DialogTemplate className="w-screen max-w-screen-sm">
      <Overlay isVisible={saving}>
        <FormErrors data={data} validators={{
          name: [validators.isRequired],
          subdomain: [validators.isRequired],
          city: [validators.isRequired],
          state: [validators.isRequired]
        }}>
          {({errors, hasError}) => {
            if (success) {
              return (
                <Confirmation
                  data={data}
                  onClose={() => {
                    props.onClose();
                    setTimeout(function() {
                      props.onSubmit && props.onSubmit(request)
                    }, 300);
                  }}
                />
              );
            }

            return (
              <Form
                data={data}
                errors={errors}
                showErrors={showErrors}
                onChange={onChange}
                onSubmit={() => hasError ? setShowErrors(true) : onSubmit()}
                onClose={props.onClose}
                alert={error ? (
                  <RequestError request={request}/>
                ) : showErrors ? (
                  <ErrorMessage>
                    Please fill in all required fields.
                  </ErrorMessage>
                ) : (false && success) ? (
                  <SuccessMessage>
                    Network updated.
                  </SuccessMessage>
                ) : null}
              />
            );
          }}
        </FormErrors>
      </Overlay>
    </DialogTemplate>
  );
};
